export const GET_NOTIFICATIONS_REQUEST = 'NOTIFICATIONS/GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS/GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'NOTIFICATIONS/GET_NOTIFICATIONS_FAILURE';
export const GET_UNREAD_COUNT_REQUEST = 'NOTIFICATIONS/GET_UNREAD_COUNT_REQUEST';
export const GET_UNREAD_COUNT_SUCCESS = 'NOTIFICATIONS/GET_UNREAD_COUNT_SUCCESS';
export const GET_UNREAD_COUNT_FAILURE = 'NOTIFICATIONS/GET_UNREAD_COUNT_FAILURE';
export const POST_MARK_AS_READ_REQUEST = 'NOTIFICATIONS/POST_MARK_AS_READ_REQUEST';
export const POST_MARK_AS_READ_SUCCESS = 'NOTIFICATIONS/POST_MARK_AS_READ_SUCCESS';
// Was the GET failure's string, so a failed mark-as-read looked like a failed list load.
export const POST_MARK_AS_READ_FAILURE = 'NOTIFICATIONS/POST_MARK_AS_READ_FAILURE';
export const POST_MARK_ALL_AS_READ_REQUEST = 'NOTIFICATIONS/POST_MARK_ALL_AS_READ_REQUEST';
export const POST_MARK_ALL_AS_READ_SUCCESS = 'NOTIFICATIONS/POST_MARK_ALL_AS_READ_SUCCESS';
export const POST_MARK_ALL_AS_READ_FAILURE = 'NOTIFICATIONS/POST_MARK_ALL_AS_READ_FAILURE';
